/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
import VPagination from "@hennge/vue3-pagination";
import Multiselect from "@vueform/multiselect";

export default {
    name: "createCraIssue",
    components: {
        customModal,
        VPagination,
        Multiselect
    },
    emits: ["closeModal", "showSetVersion"],
    props: {
        studyId: {
            type: String,
            default: "",
        },
        crasiteId: {
            type: String,
            default: "",
        },
        issueId: {
            type: [Number, String],
            default: null
        },
        cravisitName:{
            type:String,
            default:""
        },
        crasiteCode:{
            type:String,
            default:""
        },
        // crasiteId:{
        //     type: String,
        //     default: "",
        // }
        
    },

    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            token: "",
            selectedRole: null,
            roleList: [],
            userList: [],
            showLoading: false,
            totalItems: 0,
            showAddValidationRuleModal: false,
            isEditing: false,
            loadingValidationRule: false,
            isEditing: false,
            editingId: null,
            visitTypes: [],      
            visitType: "", 
            visitNo: "",
            studyId: "",
            visitId: "",
            subject: "",
            category: "",
            severity: "",
            priority: "",
            status: "",
            linkedVisitId: "",
            summary: "",
            reporterEmail: "",
            assignEmail: "",
            dateIdentified: "",
            dateOfIssue: "",
            tags: [],
            visitName: "",
            siteCode:"",
            dueAt: "",
            resolvedAt: "",
            references: [{
                type: "",
                label: "",
                url: ""
            }
            ],

            errors: {
                subject: false,
                category: false,
                severity: false,
                priority: false,
                status: false,

                reporterEmail: false,
                assignEmail: false,
            },

            errorMessages: {
                subject: '',
                category: '',
                severity: '',
                priority: '',
                status: '',
                reporterEmail: '',
                assignEmail: '',
            },
        };
    },

    computed: {
    visitNameFromStore() {
        return store.getters.getVisitName;
    },
    siteCodeFromStore() {
        return store.getters.getSiteCode;
    },
    siteIdFromStore() {
        return store.getters.getSiteId;
    }
},

    watch: {
        subject: {
            handler(newVal) {
                if (newVal) {
                    this.errors.subject = false;
                }
            }
        },
        category: {
            handler(newVal) {
                if (newVal) {
                    this.errors.category = false;
                }
            }
        },
    },

    async mounted() {
        this.token = store.getters.getIdToken;
        this.studyId = store.getters.getStudyIs;
        this.getRoleList(); 
         await this.getVisitTypes();
        console.log("Mounted with issueId:", this.issueId);
        if (this.issueId) {
            this.isEditing = true;
            this.editingId = this.issueId;
            await this.getIssueById();
           
        }
    },


    methods: {
     async getDesignationUser(role) {
  try {
    const idtoken = store.getters.getIdToken;

    const res = await axios.post(
      `${this.baseurl}/account-core/user/getuserlistbyroles?studyid=${store.getters.getStudyIs}`,
      [role],
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    );

    const users = Array.isArray(res.data) ? res.data : [];

    // Merge users
    this.userList.push(...users);

    // Remove duplicates (by email or id)
    this.userList = this.userList.filter(
      (user, index, self) =>
        index === self.findIndex(u => u.email === user.email)
    );

  } catch (err) {
    console.error("Failed to load users by role", err);
  }
}
,
async onRoleChange(selected) {
  this.showSave = true;
  this.userobject = [];
  this.userList = [];
  this.isSelectedUser = [];
  this.isRequired = [];

  if (Array.isArray(selected)) {
    for (let roleId of selected) {
      await this.getDesignationUser(roleId);
    }
  } else if (selected) {
    await this.getDesignationUser(selected);
  }
},

    async getRoleList() {
      try {
        const res = await axios.get(`${this.baseurl}/account-core/roles/rolelist`, {
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          }
        });
        this.roleList = res.data;
      } catch (err) {
        console.error("Error getting role list:", err);
      }
    },


        async getIssueById() {
            const idtoken = store.getters.getIdToken;

            try {
                const res = await axios.get(
                    `${this.baseurl}/forms/cra/getcraissuebyid`,
                    {
                        params: { issueId: this.issueId },
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                );

                const data = res.data || {};
                this.subject = data.subject || "";
                this.category = data.category || "";
                this.issueLogId = data.issueLogId || "";
                this.visitName = data.visitName || "";
                this.visitType = data.visitType || "";
                this.severity = data.severity || "";
                this.priority = data.priority || "";
                this.status = data.status || "";
                this.summary = data.summary || "";
                this.reporterEmail = data.reporterEmail || "";
                this.assignEmail = data.assignEmail || "";
                this.dateIdentified = data.dateIdentified || "";
                this.dateOfIssue = data.dateOfIssue || "";
                this.tags = Array.isArray(data.tags) ? data.tags : [];
                this.linkedVisitId = data.linkedVisitId || "";
                this.dueAt = this.formatDateForInput(
                    data.metrics?.dueAt || data.dueAt
                );

                this.resolvedAt = this.formatDateForInput(
                    data.metrics?.resolvedAt || data.resolvedAt
                );
                this.references = [
                    {
                        type: "",
                        label: "",
                        url: ""
                    }
                ];

                const refSource =
                    data.References ||
                    data.references ||
                    data.metrics?.References ||
                    data.metrics?.references ||
                    null;


                if (Array.isArray(refSource) && refSource.length > 0) {
                    const r = refSource[0];

                    this.references[0].type = r.type || r.Type || "";
                    this.references[0].label = r.label || r.Label || "";
                    this.references[0].url = r.url || r.Url || "";
                }
                else if (refSource && typeof refSource === "object") {
                    // handle single object case
                    this.references[0].type = refSource.type || refSource.Type || "";
                    this.references[0].label = refSource.label || refSource.Label || "";
                    this.references[0].url = refSource.url || refSource.Url || "";
                }

            } catch (err) {
                console.error("Failed to load issue by ID", err);
                alert("Failed to load issue details");
            }
        },
    async getVisitTypes() {
        try {
            const res = await axios.get(
                `${this.baseurl}/forms/cra/getcravisittype`,
                {
                    params: { studyId: this.studyId },
                    headers: { Authorization: `Bearer ${this.token}` }
                }
            );
            this.visitTypes = Array.isArray(res.data) ? res.data : [];
        } catch (err) {
            console.error("Failed to load visit types", err);
            this.visitTypes = [];
        }
    },


        formatDateForInput(dateStr) {
            if (!dateStr) return "";
            return dateStr.split("T")[0];
        },
        closeValidation() {
            this.$emit("closeModal");
        },

        clearErrors() {
            Object.keys(this.errors).forEach(key => {
                this.errors[key] = false;
            });
            Object.keys(this.errorMessages).forEach(key => {
                this.errorMessages[key] = '';
            });
        },
        SortSelected(property) {
            if (this.SortProperty === property) {
                this.SortOrder = this.SortOrder === 0 ? 1 : 0;
            } else {
                this.SortProperty = property;
                this.SortOrder = 0;
            }
        },

        // validate() {
        //     this.clearErrors();
        //     let isValid = true;

        //     if (!this.subject.trim()) {
        //         this.errors.subject = true;
        //         this.errorMessages.subject = this.$t("navigations.please enter a subject");
        //         isValid = false;
        //     }

        //     if (!this.category.trim()) {
        //         this.errors.category = true;
        //         this.errorMessages.category = this.$t("navigations.please enter a category");
        //         isValid = false;
        //     }

        //     if (!this.severity) {
        //         this.errors.severity = true;
        //         this.errorMessages.severity = this.$t("navigations.please select severity");
        //         isValid = false;
        //     }

        //     if (!this.priority) {
        //         this.errors.priority = true;
        //         this.errorMessages.priority = this.$t("navigations.please select priority");
        //         isValid = false;
        //     }

        //     if (!this.status) {
        //         this.errors.status = true;
        //         this.errorMessages.status = this.$t("navigations.please select status");
        //         isValid = false;
        //     }

        //     if (!this.reporterEmail.trim()) {
        //         this.errors.reporterEmail = true;
        //         this.errorMessages.reporterEmail = this.$t("navigations.please enter reporter email");
        //         isValid = false;
        //     }

        //     if (!this.assignEmail.trim()) {
        //         this.errors.assignEmail = true;
        //         this.errorMessages.assignEmail = this.$t("navigations.please enter assign email");
        //         isValid = false;
        //     }

        //     return isValid;
        // },

        async saveValidationRule() {
            console.log("this.cravisitName",this.cravisitName);
            this.loadingValidationRule = true;
            const idtoken = store.getters.getIdToken;
            const stdid = store.getters.getStudyIs;

            const payload = {
                createdUserEmail: store.getters.getUserEmail,
                createdUserId: store.getters.getUserId,
                createdAt: new Date().toISOString(),
                lastModifiedUserEmail: store.getters.getUserEmail,
                lastModifiedUserId: store.getters.getUserId,
                lastModifiedAt: new Date().toISOString(),
                studyId: stdid,
                subject: this.subject?.trim() || null,
                issueLogId: this.issueLogId || null,
                siteId: this.crasiteId || this.siteIdFromStore || null,
                siteCode: this.crasiteCode || this.siteCodeFromStore || null,
                visitName: (this.cravisitName || this.visitNameFromStore)?.trim() || null,

                visitType: this.visitType?.trim() || null,
                severity: this.severity || null,
                priority: this.priority || null,
                status: this.status || null,
                summary: this.summary || null,
                dateIdentified: this.dateIdentified || null,
                dateOfIssue: this.dateOfIssue || null,
                assignEmail: this.assignEmail?.trim() || null,
                reporterEmail: this.reporterEmail?.trim() || null,
                visitId: this.linkedVisitId || null,
                visitNo : this.visitNo || null,
                tags: Array.isArray(this.tags) ? this.tags : [],
                metrics: {
                    dueAt: this.dueAt || null,
                    firstResponseAt: this.firstResponseAt || "",
                    resolvedAt: this.resolvedAt || null,
                },
                references: Array.isArray(this.references)
                    ? this.references
                        .filter(r => r.label || r.url)
                        .map(r => ({
                            type: r.type || null,
                            label: r.label?.trim() || null,
                            url: r.url?.trim() || null,
                        }))
                    : [],
            };


            console.log("Payload being sent:", payload);

            try {
                if (this.isEditing && this.editingId) {
                    
                    await axios.put(
                        `${this.baseurl}/forms/cra/updatecraissue`,

                        { craIssueId: this.editingId, ...payload },
                        {
                            headers: {
                                Authorization: "Bearer " + idtoken,
                                "Content-Type": "application/json",
                            },
                        }
                    );
                    alert(this.$t("navigations.cra issue updated successfully"));
                    this.$emit("showIssue", true);
                    this.$emit("close", true);
                } else {
                    await axios.post(
                        `${this.baseurl}/forms/cra/createcraissue`,
                        payload,
                        {
                            headers: {
                                Authorization: "Bearer " + idtoken,
                                "Content-Type": "application/json",
                            },
                        }
                    );
                    alert(this.$t("navigations.cra issue created successfully"));
                }

                this.$emit("showSetVersion", true);
                this.resetForm();
                this.showAddValidationRuleModal = false;
                
            } catch (err) {
                console.error("Save CRA issue failed:", err);
                alert(err.response?.data?.detail || err.response?.data?.message || "Save operation failed");
            } finally {
                this.loadingValidationRule = false;
            }
        },

        resetForm() {
            this.subject = "";
            this.references = [{ Type: "", Label: "", Url: "" }];
            this.visitName = "";
            this.visitType="";
            this.category = "";
            this.severity = "";
            this.priority = "";
            this.status = "";
            this.linkedVisitId = "";
            this.summary = "";
            this.reporterEmail = "";
            this.assignEmail = "";
            this.dateIdentified = "";
            this.dateOfIssue = "";
            this.tags = [];
            this.dueAt = "";
            this.resolvedAt = "";
            this.isEditing = false;
            this.editingId = null;
            this.clearErrors();
        },
        closeCraIssue() {
            this.$emit("close");
        }
    },
};
